<script setup lang="ts">
import type { DropdownMenuItem } from '@nuxt/ui';
import { computed } from 'vue';
import { useRevertMenuItem } from '#layers/forms/composables/use-revert-menu-item';
import FieldLabelMenu from './FieldLabelMenu.vue';

const {
	dirty,
	disabled,
} = defineProps<{
	label: string; // Used for aria-label, not rendered
	disabled?: boolean;
	dirty?: boolean;
}>();

const emit = defineEmits<{ revert: [] }>();

const revertItem = useRevertMenuItem({
	dirty: () => dirty,
	disabled: () => disabled,
	onRevert: () => emit('revert'),
});

const menuItems = computed<DropdownMenuItem[][]>(() =>
	revertItem.value ? [[revertItem.value]] : [],
);
</script>

<template>
	<FieldLabelMenu v-if="menuItems.length > 0" :label :items="menuItems" />
</template>
